import request from '@/utils/request';

export async function query(payload) {
    return request(`/iwms-wms/wms/containerasset/recycle/query`, {
        method: 'POST',
        body: payload,
    });
}

export async function get(payload) {
    return request(`/iwms-wms/wms/containerasset/recycle/get?dcUuid=${payload.dcUuid}&storeUuid=${payload.storeUuid}`);
}

export async function recycleByQty(payload) {
    return request(`/iwms-wms/wms/containerasset/recycle/qty?companyUuid=${payload.companyUuid}&dcUuid=${payload.dcUuid}&storeUuid=${payload.storeUuid}`, {
        method: 'POST',
        // body: payload,
    });
}

export async function recycleByQtys(payload) {
    return request(`/iwms-wms/wms/containerasset/recycle/qtybyqty`, {
        method: 'POST',
        body: payload,
    });
}

export async function recycleByBarcode(payload) {
    return request(`/iwms-wms/wms/containerasset/recycle/barcode?companyUuid=${payload.companyUuid}&dcUuid=${payload.dcUuid}&containerBarcode=${payload.containerBarcode}`, {
        method: 'POST',
        // body: payload,
    });
}

export async function recycleByStores(payload) {
    return request(`/iwms-wms/wms/containerasset/recycle/qty?companyUuid=${payload.companyUuid}&dcUuid=${payload.dcUuid}&storeUuid=${payload.storeUuid}`, {
        method: 'POST'
    });
}

export async function qtyPage(payload) {
    return request(`/iwms-wms/wms/containerasset/recycle/qty/page`, {
        method: 'POST',
        body: payload,
    });
}

export async function qtyBatchRecycle(payload) {
    return request(`/iwms-wms/wms/containerasset/recycle/qty/batchRecycle`, {
        method: 'POST',
        body: payload,
    });
}